import { createSelector } from 'reselect'

import { IRootState } from '../../root'

export const selectOrderSettingsState = (state: IRootState) => state.order.orderSettings

export const selectOrderSettings = createSelector(selectOrderSettingsState, (state) => state.item)
